import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputFile, SelectInput, Collapsible, DatePicker, InputValidation, Table, Chips, Accordion, Spinner, Pagination,Modal  } from '@sogei/react-web-components-catalog'
import { breadcrumbRicevutePegno, breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import { tableHeadPegni,tableHeadUnico ,tableHeadPegniCertificati, tableHeadUnimod} from '../../assets/tableHeaders';
import i18next from 'i18next';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { decodeTipologica, scrollToTop } from '../commons/uiUtils';
import { regExpDate, regExpOnlyNumbers } from '../../assets/utils/regexp';
import { RicevutaFirmataENon } from '../ricevute/ricevutaFirmataENon';
import { DownloadDocumento } from '../ricevute/downloadDocumento';
import { DatiRicerca } from '../ricevute/datiRicerca';
import { DettaglioButton } from '../ricevute/dettaglioButton';
import { IN_ATTESA_CONTROLLI_BLACKBOX } from '../../config/presdoc-fe-config';


@inject("rootStore")
@observer
class EsitiContestuali extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      generaPlicoConcluso:false
    }
    this.tipologicaStore = props.rootStore.tipologicaStore;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    this.trasmissioneStore = props.rootStore.trasmissioneStore;
    this.qualificheStore = props.rootStore.qualificheStore;
    this.tipoPratica = this.qualificheStore.tipoPratica;
    
  
  }

  componentDidMount() {
    let tentativi = 90;
    var interval = setInterval
    (() => {
      //loading this.ricevuteStore.setLoading(true);

      let paramEsitiPrimoLivello = {
        idPraticaDa: this.trasmissioneStore.codiceInvio,
        idPraticaA: this.trasmissioneStore.codiceInvio, 
       //idPraticaDa: 58835285, //per prove in locale
       //idPraticaA: 58835285, //per prove in locale
        flagProva: "B",
        tipoPratica: "UN",
        codiceFiscaleRiferimento: this.props.rootStore.qualificheStore.codiceFiscaleRiferimento(),
        identificativoUtenza: this.props.rootStore.qualificheStore.qualifica.identificativoUtenza,

      }

      this.ricevuteStore.esitiPrimoLivello(paramEsitiPrimoLivello).then(() => {

        if (this.ricevuteStore.esitiPrimoLivelloUnico !== undefined && this.ricevuteStore.esitiPrimoLivelloUnico.every(x => x.statoPratica != IN_ATTESA_CONTROLLI_BLACKBOX)) {
          console.log(".....esitiPrimoLivello finito")

          let paramEsitiSecondoLivello = {
            idPratica: this.trasmissioneStore.codiceInvio,
            //idPratica: 58835285, //per prove in locale
            codiceFiscaleRiferimento: this.props.rootStore.qualificheStore.codiceFiscaleRiferimento(),
            identificativoUtenza: this.props.rootStore.qualificheStore.qualifica.identificativoUtenza,
            annoPratica: new Date().getFullYear()
          }
          console.log("paramEsitiSecondoLivello", JSON.stringify(paramEsitiSecondoLivello));
          this.ricevuteStore.esitiSecondoLivello(paramEsitiSecondoLivello).then(() => {
            console.log(".....esitiSecondoLivello finito ", JSON.stringify(this.ricevuteStore.esitiSecondoLivelloUnico))
            clearInterval(interval);
          }).catch((e) => {
            console.log("Sono nel catch di generaControllaPlico", e);
            var msg = "Si è verificato un errore. Contattare l'assistenza.";
            this.props.rootStore.uiStore.addDangerMessage({ "text": msg })
            this.setState({
              generaPlicoConcluso: true
            })
            clearInterval(interval);
          });



          this.setState({ generaPlicoConcluso: true });
          //this.ricevuteStore.setLoading(false);
          clearInterval(interval);
        }
        tentativi = tentativi - 1;
        console.log(tentativi)
        if (tentativi === 0) {
          this.setState({ generaPlicoConcluso: true });
          //this.ricevuteStore.setLoading(false);;
          clearInterval(interval);
          scrollToTop();
        }
      })
        .catch((e) => {
          console.log("sono nel catch di esitiPrimoLivello",e)

          tentativi = tentativi - 1;
          if (tentativi === 0) {
            this.setState({ generaPlicoConcluso: true });
            //this.ricevuteStore.setLoading(false);;
            clearInterval(interval);
            scrollToTop();
          }
        })

    }, 5000)
  }

  

    render() {    
        
   

      /*const pagination = this.ricevuteStore.pagination ? this.ricevuteStore.pagination : []
      const filtriRicerca = this.ricevuteStore.filtriRicerca;
      const listaStatiInvio = this.tipologicaStore.statoInvio; */
      //const ricevute = this.ricevuteStore.esitiSecondoLivelloUnico?this.ricevuteStore.esitiSecondoLivelloUnico:[];
      
      const loading = this.ricevuteStore.loading;

      
    

    
    const tableHead = (tableHeader)=>{
      //console.log(tableHeader)
      let thLivello1 = tableHeader.filter(x => x.livello==1 ).map( cellaHeader => {
        const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
        return cella;
      })

      let thLivello2 = tableHeader.filter(y => y.livello==2 ).map( cellaHeader => {
        const cella = <th style={{verticalAlign:"middle"}} className= {cellaHeader.classNameHeader}  colSpan={cellaHeader.colSpan} rowSpan={cellaHeader.rowSpan}> {i18next.t(cellaHeader.label)} </th>
        return cella;
      })
      
      let output = 
      <>
        <tr> {thLivello1}
      </tr>
      <tr> {thLivello2}
      </tr>
    
      </>
      return output;
  }

 
  

  const servizioStatoPratica = (item,index) =>  {
    let erroreUtente = this.ricevuteStore.erroreUtente
    let colonnaStato;
    colonnaStato =  " ";
    //if((item.statoPegno==13||item.statoPegno==14||item.statoPegno==15)&&item.erroreUtente!='-') {
      if(item.statoPegno>10&&item.erroreUtente!='-') {
      console.log('item.idPratica||:item.statoPegno||item.erroreUtente:',item.idPratica,': ',item.statoPegno,item.erroreUtente);
     
      colonnaStato =  <>
      <Modal labelId="label" containerId="containerIdStatoPratica" title="Motivazione scarto" body={
         <p>
              {erroreUtente === undefined ? "" : erroreUtente}
            </p> 
            }>
        {" "}
      </Modal>           
      <button type="button" className="btn btn-light border border-danger" data-toggle="modal" data-target="#containerIdStatoPratica" onClick={() => this.ricevuteStore.messaggioErrore(item.erroreUtente)}>
            {item.descStato}
      </button>             
      </> 



    }
   /*  else if((item.stato==2&&item.esito==3&&!item.duplo)||(item.stato==1&&item.esito==0&&!item.duplo)) {
      colonnaStato =  <>
      <Modal labelId="label" containerId="containerIdStatoPratica" title="Stato pratica" body={
            <p>
              {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.esito != 0 ? "Servizio di recupero dello stato non disponibile, si prega di riprovare più tardi." : "Domanda del pegno depositata presso l'ufficio in data: "} <b>{statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.dataRicezione} {statoPraticaRisultato === undefined ? "" : statoPraticaRisultato.statoLavorazione == 1 ? ", in lavorazione" : ""}</b>
            </p>
            }>
        {" "}
      </Modal>           
      <button type="button" className="btn btn-light border" data-toggle="modal" data-target="#containerIdStatoPratica"  onClick={() => this.ricevuteStore.chiamataStatoPratica(item)}>
            {item.descStatoElaborazione}
      </button>             
      </> 
    } */
    else {
      colonnaStato= '-';//item.descStato'';
    }
    return colonnaStato;
  }
 

  const tableBody = tableHeader =>
   {
    console.log("###### tableBody ricevute:" + JSON.stringify(this.ricevuteStore.esitiSecondoLivelloUnico))
    if( !this.ricevuteStore.esitiSecondoLivelloUnico){
      console.log("sono dentro l'if")
     return (<tr><td colSpan="10" key={"0"}><span>{i18next.t("TABLE_NO_RESULTS")}</span></td></tr>)
    }
     else
   {
    console.log("sono dentro l'else")
   const output=  this.ricevuteStore.esitiSecondoLivelloUnico.map((item,index) => { return (
      <tr key={'result_'+item.idPratica+'_'+index}>
       {tableHeader.filter(z => z.type!=='td-none').map(element => {
       
        return <td className={element.classNameCella}>{
          element.type==='text'?item[element.nomeKeyServizio]
          :
          element.type==='dettaglio'? <DettaglioButton item= {item} element = {element} valori = {this.formikRef?this.formikRef.state.values:this.ricevuteStore.filtriRicercaStored} tipoPratica = {this.tipoPratica} livelloTarget={2}/>
          :
          element.type==='ricevutaFirmataENon'?  <RicevutaFirmataENon item={item} element = {element}/>
          :
          element.type==='downloadDocumento'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='downloadDocumentoAtmos'? <DownloadDocumento item={item} element = {element}></DownloadDocumento>
          :
          element.type==='servizioStatoPratica'? servizioStatoPratica(item,index)
          :
          undefined}
          </td>
        
       })
       } 
      </tr>
  )
  })
  return output;

  
  }

  }

  
  
  

  
  
  
        
        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
           <div className="row">              
              <div className="col">
                <h1>{i18next.t("RICEVUTE_TITLE")}</h1>
               

              
                
                {!this.state.generaPlicoConcluso && <Spinner isLoading={true}> </Spinner>}
                {this.state.generaPlicoConcluso && (<>
                  <div className='row align-items-center'>
                  {/*<div className='col'>
                      <span>{i18next.t("FILTRI_APPLICATI")}</span>
                      {getDateFilter()}
                      {getCodiceInvioFilter()}
                      {getStatoInvioFilter()}
                    </div>*/}
                  </div>
                  <div className='row mt-3'>
                      <div className='col'>
                      <Table tableHead={tableHead(this.tipoPratica === 'MP' ? tableHeadPegni:this.tipoPratica === 'UN'? tableHeadUnimod :this.tipoPratica === 'CP'? tableHeadPegniCertificati: undefined)} tableBody={ tableBody(this.tipoPratica === 'MP' ? tableHeadPegni:this.tipoPratica === 'UN'? tableHeadUnimod :this.tipoPratica === 'CP'? tableHeadPegniCertificati: undefined)} tableOptions={['table-header']} />
                      </div>
                  </div>
                  
                </>)}
              </div>
            </div>
          </div>
        ); 
      }
}


export default EsitiContestuali

export { EsitiContestuali }

